import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService, UserInfoDto } from '@uoa/auth';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { AsyncPipe } from '@angular/common';
import { person } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { IonIcon, IonMenuButton } from '@ionic/angular/standalone';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [IonMenuButton, IonIcon, AsyncPipe]
  })
export class HeaderComponent {
  private readonly loginService = inject(LoginService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  userInfo$: Observable<UserInfoDto>;

  constructor() {
    this.userInfo$ = this.userService.user$;
    addIcons({person});
  }

  async login() {
    await this.loginService.doLogin(this.router.url);
  }
}
